import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/routes';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import { green, red } from '@material-ui/core/colors';
import EmailConfirmationDialog from 'pages/dashboard/EmailConfirmationDialog';
import { confirmEmail } from 'actions/user';
import Step1 from 'assets/images/gettingStartedStep1.png';
import Step2 from 'assets/images/gettingStartedStep2.png';
import Step3 from 'assets/images/logo-shopify.png';
import {
  Container,
  Heading,
  StepSection,
  Step,
  Img,
  Description,
  Text,
} from 'styles/pages/dashboard/recommendedSteps';

const RecommendedSteps = ({ user }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const emailId = useSelector((state) => state?.auth?.profile?.emailid);
  const fullName = useSelector((state) => state?.auth?.profile?.FullName);
  const id = useSelector((state) => state?.auth?.profile?.ID);
  const [emailConfirmation, setEmailConfirmation] = useState(false);

  if (user?.UserStores?.length && user?.User?.EmailConfirmed) {
    return null;
  }

  return (
    <Container>
      <Heading>Recommended Steps</Heading>
      <StepSection>
        <Step disabled={true}>
          <Img src={Step1} alt='step1' />
          <Description>
            <CheckCircleIcon style={{ color: green[500] }} />
            <Text>Sign up for Big Oven Tees</Text>
          </Description>
        </Step>

        <Step
          disabled={user?.User?.EmailConfirmed}
          onClick={async () => {
            if (user?.User?.EmailConfirmed) {
              return;
            }
            const request = await dispatch(
              confirmEmail({
                user: emailId,
                fullName,
                id,
              })
            );
            if (request?.error) {
              return;
            }
            setEmailConfirmation(true);
          }}>
          <Img src={Step2} alt='step1' />
          <Description>
            {user?.User?.EmailConfirmed ? (
              <CheckCircleIcon style={{ color: green[500] }} />
            ) : (
              <WarningIcon style={{ color: red[500] }} />
            )}
            <Text>Confirm your email</Text>
          </Description>
        </Step>

        <Step
          style={{ textAlign: 'center' }}
          disabled={!user?.User?.EmailConfirmed}
          onClick={() => {
            if (!user?.User?.EmailConfirmed) {
              return;
            }
            history.push(ROUTES.MY_STORES_REGISTRATION.LINK);
          }}>
          <Img src={Step3} alt='step1' style={{ width: 100 }} />
          <Description>
            {!user?.UserStores?.length ? (
              <RadioButtonUncheckedIcon />
            ) : (
              <CheckCircleIcon style={{ color: green[500] }} />
            )}
            <Text>Connect your store</Text>
          </Description>
        </Step>
      </StepSection>
      {emailConfirmation && (
        <EmailConfirmationDialog
          open={emailConfirmation}
          setOpen={(v) => setEmailConfirmation(v)}
        />
      )}
    </Container>
  );
};

export default RecommendedSteps;
